<template>
  <a-modal
    destroyOnClose
    :footer="null"
    :maskClosable="false"
    centered
    :title="$t('title.ReceiptDetailSearch')"
    v-model="visible"
    width="85%">
    <a-space>
      <a-input-search
        style="width: 200px"
        @pressEnter="filterByNo"
        @search="filterByNo"
        :placeholder="$t('business.label.itemNo')"
        v-model="query['no']"
      />
      <a-input-search
        style="width: 200px"
        @pressEnter="filterByName"
        @search="filterByName"
        :placeholder="$t('business.label.itemName')"
        v-model="query['name']"
      />
      <a-input-search
        style="width: 200px"
        @pressEnter="filterByBarcode"
        @search="filterByBarcode"
        :placeholder="$t('business.label.itemBarcode')"
        v-model="query['barcode']"
      />
      <a-button type="primary" @click="reset">{{ $t('button.reset') }}</a-button>
    </a-space>
    <br /><br />
    <vxe-table
      border
      stripe
      round
      show-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :height="500"
      size="mini"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      @cell-dblclick="rowDblClick">
      <vxe-column fixed="left" type="seq" width="40"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="150" />
      <vxe-column field="item.name" title="business.label.itemName" width="200" />
      <vxe-column field="pack.specification" title="business.label.specification" width="150" />
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="lot.manufacturer" title="business.label.manufacturer" width="150" />
      <vxe-column field="lot.no" title="business.label.lot" width="150" />
      <vxe-column field="storageRoom.name" title="business.label.storageRoomName" width="150" />
      <vxe-column field="lot.productionDate" title="business.label.productionDate" width="100" />
      <vxe-column field="lot.validUntil" title="business.label.validUntil" width="100" />
      <vxe-column field="lot.approvalNo" title="business.label.approvalNo" width="150" />
      <vxe-column field="detail.invoiceQuantity" title="business.label.invoiceQuantity" width="150" />
      <vxe-column field="detail.receivedQuantity" title="business.label.receivedQuantity" width="150" />
      <vxe-column field="detail.rejectedQuantity" title="business.label.rejectedQuantity" width="150" />
      <vxe-column field="detail.inspectedQuantity" title="business.label.inspectedQuantity" width="150" />
      <vxe-column field="detail.acceptedQuantity" title="business.label.acceptedQuantity" width="150" />
      <vxe-column field="detail.rejectedQuantityOfAcceptance" title="business.label.rejectedQuantityOfAcceptance" width="150" />
    </vxe-table>
  </a-modal>
</template>
<script>
  export default {
    name: 'InspectDetailModal',
    data() {
      return {
        visible: false,
        loading: false,
        data: [],
        query: {
          'no': '',
          'name': '',
          'barcode': ''
        },
        selectedRowKeys: [],
        selectedRows: [],
        bakData: []
      }
    },
    props: {
      selectType: {
        type: String,
        default: 'radio'
      },
      title: {
        type: String,
        default: '收货明细检索'
      }
    },
    methods: {
      open(dtls) {
        this.visible = true
        let i = 1
        dtls.forEach(dtl => {
          dtl.key = i++
        })
        this.bakData = Object.assign([], dtls)
        this.data = dtls
      },
      filterByNo() {
        this.data = this.data.filter(dtl => dtl.item.no.includes(this.query['no']))
      },
      filterByName() {
        this.data = this.data.filter(dtl => dtl.item.name.includes(this.query['name']))
      },
      filterByBarcode() {
        this.data = this.data.filter(dtl => dtl.item.barcodes.includes(this.query['barcode']))
      },
      rowDblClick() {
        this.confirm()
      },
      handleCancel() {
        this.visible = false
      },
      confirm() {
        this.$emit('change', this.$refs.table.getCurrentRecord())
        this.visible = false
      },
      reset() {
        this.query = {
          'no': '',
          'name': '',
          'barcode': ''
        }
        this.data = Object.assign([], this.bakData)
      }
    }
  }
</script>
